<template>
  <wa-page :is-showing-bandana="false" :is-showing-sitewide-modal="false">
    <wa-page-header
      slot="header"
      key="header"
    />

    <main
      slot="content"
      role="main"
      class="app-content"
    >
      <hero
        :last-updated="lastUpdated"
        :last-updated-formatted="lastUpdatedFormatted"
      />

      <div class="container padding-y-7xl">
        <div class="row roomy align-stretch margin-bottom-4xl">
          <div class="column-12 margin-bottom-2xl laptop:column-8 laptop:margin-bottom-0">
            <licenses />
            <attribution />
          </div>

          <div class="column-12 laptop:column-4">
            <dos />
            <donts />
          </div>
        </div>

        <div class="margin-bottom-2xl">
          <see-pro-license />
        </div>

        <license-sock slot="sock" />
      </div>
    </main>

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import moment from 'moment'
  import { EventTrackingMixin } from 'app/mixins'

  import Attribution from './sections/free/Attribution'
  import Donts from './sections/free/Donts'
  import Dos from './sections/free/Dos'
  import Hero from './sections/free/Hero'
  import Licenses from './sections/free/Licenses'
  import LicenseSock from './sections/LicenseSock'
  import SeeProLicense from './sections/free/SeeProLicense'

  export default {
    name: 'FreeLicenseView',

    components: {
      Attribution,
      Donts,
      Dos,
      Hero,
      Licenses,
      LicenseSock,
      SeeProLicense
    },

    mixins: [EventTrackingMixin],

    data() {
      return {
        lastUpdated: '2018-07-12'
      }
    },

    computed: {
      lastUpdatedFormatted() {
        return moment(this.lastUpdated).format('LL')
      }
    },

    mounted() {
      this.$posthog.capture('free_license_view', this.determinationsEventProps)
    }
  }
</script>
